
<template>
  <div class="root-container">
    <el-form   label-width="150px">
      <el-form-item label="续期天数" >
        <el-input-number style="width: 300px;" v-model="extentDay"></el-input-number>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer-1" >
      <el-button type="primary" @click="onBtnSure()">确认</el-button>
    </div>
  </div>
</template>

<style>
</style>

<script>
  import globaldata from "../../../utils/globaldata";
  import messageUtils from "../../../utils/messageUtils";
  import commonUtils from "../../../utils/commonUtils";
  import {extendAllVIPCardDay} from "../../../api/userByCard";


  export default {
    components:{},
    name: 'ExtentCardDay',
    props: {
      lessonTemplateId:Object
    },
    data() {
      return {
        extentDay: 0,
      }
    },
    created(){

    },
    methods: {
      onBtnSure(){
        let param = {
          adminId :globaldata.getAdminStore().id,
          storeFrontId:globaldata.getAdminStore().storeFrontId,
          lessonTemplateId:this.lessonTemplateId,
          day:this.extentDay
        }
        extendAllVIPCardDay(param).then(response =>
        {
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            messageUtils.errorMsg(this,response.message)
          }else {
            messageUtils.successMsg(this,response.message)

            this.$emit('onBtnOk');
          }
        });

      }
    }
  }
</script>






// WEBPACK FOOTER //
// src/views/user-by-lesson-card/components/ExtentCardDay.vue